export const STUDENT_MESSAGE_TEMPLATE_VARIABLES = [
  { key: '{{firstName}}', label: 'Prénom' },
  { key: '{{lastName}}', label: 'Nom' },
  { key: '{{email}}', label: 'Email' },
  { key: '{{courseTitle}}', label: 'Titre de la formation (langue en cours)' },
  { key: '{{companyName}}', label: 'Entreprise' },
  { key: '{{groupName}}', label: 'Groupe' },
  { key: '{{progressPercentage}}', label: 'Avancement (%)' },
  { key: '{{daysSinceLastActivity}}', label: 'Jours d\'inactivité' },
  { key: '{{incompleteCapsulesList}}', label: 'Items non terminés' },
  { key: '{{diagnosticReminderBlock}}', label: 'Bloc rappel diagnostic' },
  { key: '{{impactReminderBlock}}', label: 'Bloc rappel mesure d\'impact' },
  { key: '{{capsulesBeforeWorkshopBlock}}', label: 'Bloc capsules avant atelier' },
  { key: '{{workshopNumber}}', label: 'Numéro d\'atelier' },
  { key: '{{workshopTime}}', label: 'Horaire atelier' },
  { key: '{{courseUrl}}', label: 'Lien formation' },
  { key: '{{impactMeasurementUrl}}', label: 'Lien mesure d\'impact' },
] as const;

export const STUDENT_MESSAGE_SEND_VARIABLES = [
  ...STUDENT_MESSAGE_TEMPLATE_VARIABLES,
  { key: '{{workshopTitle}}', label: 'Titre du prochain atelier (groupe de l\'apprenant)' },
  { key: '{{workshopDate}}', label: 'Date du prochain atelier (groupe de l\'apprenant)' },
  { key: '{{workshopLocation}}', label: 'Lieu du prochain atelier (groupe de l\'apprenant)' },
  { key: '{{workshopsDates}}', label: 'Dates de tous les ateliers (groupe de l\'apprenant)' },
] as const;

/** @deprecated Utiliser STUDENT_MESSAGE_TEMPLATE_VARIABLES */
export const STUDENT_MESSAGE_VARIABLES = STUDENT_MESSAGE_TEMPLATE_VARIABLES;
